export default "__VITE_ASSET__d8b530d3__"